/*eslint-disable react/no-set-state */
import React, { Component } from 'react'
import FlatButton from 'material-ui/FlatButton'
import PropTypes from 'prop-types'
import { DrawerHeaderBar } from '../../components/drawer/DrawerHeaderBar'
import IconButton from 'material-ui/IconButton'
import { StatefulTextField } from '../../components/common/StatefulTextField'
import NavigationClose from 'material-ui/svg-icons/navigation/close'
import { modifyVisibilityBoardEntry } from '../../graphql/relay/queries/visibilityBoard'
import { handleMutation } from '../../graphql/relay/queries/mutation'
import {environment} from "../../graphql/relay/env"
import { bindActionCreators } from 'redux'
import { showErrorsPg } from '../../ducks/errorspg'
import {connect} from 'react-redux'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Json2Toml from 'json2toml'

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        showErrorsPg
      },
      dispatch
    ),
  }
}

class EditVisibilityBoardEntry extends Component {
  static propTypes = {
    data: PropTypes.exact({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      boardTemplate: PropTypes.object.isRequired,
      footer: PropTypes.string,
      timeHeaderFormat: PropTypes.string,
      locationStatusesDisplay: PropTypes.string,
      scrollDuration: PropTypes.number,
      departmentExchangeName: PropTypes.string.isRequired,
      bedExchangeNames: PropTypes.array.isRequired,
      templates: PropTypes.array.isRequired,
      departmentItems: PropTypes.array.isRequired,
      bedMap: PropTypes.object.isRequired
    }),
    onRequestClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    actions: PropTypes.shape({
      showErrorsPg: PropTypes.func
    }),
  }
  static contextTypes = {
    styleManager: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    const sortedBedExchangeNames = [...this.props.data.bedExchangeNames].sort()
    this.state = {
      id: this.props.data.id,
      name: this.props.data.name,
      description: this.props.data.description,
      footer: this.props.data.footer,
      timeHeaderFormat: this.props.data.timeHeaderFormat,
      locationStatusesDisplay: this.props.data.locationStatusesDisplay,
      scrollDuration: this.props.data.scrollDuration,
      templateId: this.props.data.boardTemplate.id,
      departmentExchangeName: this.props.data.departmentExchangeName,
      bedExchangeNames: sortedBedExchangeNames,
      nameOriginal: this.props.data.name,
      descriptionOriginal: this.props.data.description,
      footerOriginal: this.props.data.footer,
      timeHeaderFormatOriginal: this.props.data.timeHeaderFormat,
      locationStatusesDisplayOriginal: this.props.data.locationStatusesDisplay,
      scrollDurationOriginal: this.props.data.scrollDuration,
      templateIdOriginal: this.props.data.boardTemplate.id,
      departmentExchangeNameOriginal: this.props.data.departmentExchangeName,
      bedExchangeNamesOriginal: sortedBedExchangeNames
    }
  }

  handleError = (errKey, errCode, errMessage) => {
    this.setState({
      isSubmitting: false
    })
  }

  handleNameUpdate = e => {
    this.setState({
      name: e.target.value,
    })
  }

  handleDescriptionUpdate = e => {
    this.setState({
      description: e.target.value,
    })
  }

  handleFooterUpdate = e => {
    this.setState({
      footer: e.target.value,
    })
  }

  handleLocationStatusesDisplayUpdate = (event, index, value) => {
    this.setState({
      locationStatusesDisplay: value
    })
  }

  handleDepartmentExchangeNameUpdate = (event, index, value) => {
    this.setState({
      departmentExchangeName: value,
      bedExchangeNames: []
    })
  }

  handleBedExchangeNamesUpdate = (event, index, value) => {
    const bedExchangeNameSelected = value[0]
    const found = this.state.bedExchangeNames.find((bedExchangeName) => bedExchangeName === bedExchangeNameSelected)
    //we are sorting the final result so that comparison are made easier later on
    if(typeof found === "undefined") {
       this.setState({
         bedExchangeNames: [...this.state.bedExchangeNames, bedExchangeNameSelected].sort()
       })
    } else {
      this.setState({
        bedExchangeNames: this.state.bedExchangeNames.filter((bedExchangeName) => bedExchangeName !== bedExchangeNameSelected).sort()
      })
    }
  }

  handleScrollDurationUpdate = (event, index, value) => {
    this.setState({
      scrollDuration: value
    })
  }

  handleTimeHeaderFormatUpdate = e => {
    this.setState({
      timeHeaderFormat: e.target.value,
    })
  }

  handleTemplateIdUpdate = (event, index, value)=> {
    this.setState({
      templateId: value
    })
  }

  onApplyHandler = () => {
    this.setState({
      isSubmitting: true
    })
    const variables = {
      visibilityBoardId: this.state.id,
      visibilityBoardInput: {
        name: this.state.name,
        description: this.state.description,
        footer: this.state.footer,
        timeHeaderFormat: this.state.timeHeaderFormat,
        locationStatusesDisplay: this.state.locationStatusesDisplay,
        scrollDuration: ((duration) => {
          if(this.state.scrollDuration && this.state.scrollDuration !== '') {
            return duration
          } else {
            return null
          }
        })(this.state.scrollDuration),
        templateId: this.state.templateId,
        //there was a last minute requirement to change the text field for
        //the toml configuration to a drop down selection.  To limit the changes
        //to the front end, the drop down selections for department and beds
        //are used to build the toml config which is sent to the back end
        departmentBedConfig: Json2Toml({
          department: this.state.departmentExchangeName,
          beds: this.state.bedExchangeNames
        })
      }
    }

    handleMutation(
      environment,
      modifyVisibilityBoardEntry,
      variables,
      () => {
        this.props.onRequestClose && this.props.onRequestClose()
      },
      undefined,
      this.handleError
    )
  }


  locationStatusesDisplayItems = [
    <MenuItem key={"Visible"} value={"VISIBLE"} primaryText={"Visible"} />,
    <MenuItem key={"Hidden"} value={"HIDDEN"} primaryText={"Hidden"} />,
  ]

  scrollDurationDisplayItems = [
    <MenuItem key={"5s"} value={"5"} primaryText={"5s"} />,
    <MenuItem key={"10s"} value={"10"} primaryText={"10s"} />,
    <MenuItem key={"15s"} value={"15"} primaryText={"15s"} />,
    <MenuItem key={"20s"} value={"20"} primaryText={"20s"} />,
    <MenuItem key={"25s"} value={"25"} primaryText={"25s"} />,
    <MenuItem key={"30s"} value={"30"} primaryText={"30s"} />,
    <MenuItem key={"35s"} value={"35"} primaryText={"35s"} />,
    <MenuItem key={"40s"} value={"40"} primaryText={"40s"} />,
    <MenuItem key={"45s"} value={"45"} primaryText={"45s"} />,
    <MenuItem key={"50s"} value={"50"} primaryText={"50s"} />,
    <MenuItem key={"55s"} value={"55"} primaryText={"55s"} />,
    <MenuItem key={"60s"} value={"60"} primaryText={"60s"} />,
    <MenuItem key={"65s"} value={"65"} primaryText={"65s"} />,
    <MenuItem key={"70s"} value={"70"} primaryText={"70s"} />,
    <MenuItem key={"75s"} value={"75"} primaryText={"75s"} />,
    <MenuItem key={"80s"} value={"80"} primaryText={"80s"} />,
    <MenuItem key={"85s"} value={"85"} primaryText={"85s"} />,
    <MenuItem key={"90s"} value={"90"} primaryText={"90s"} />,
  ]



  render() {
    const { title, onRequestClose, data } = this.props

    const {
      name,
      description,
      footer,
      timeHeaderFormat,
      locationStatusesDisplay,
      scrollDuration,
      templateId,
      departmentExchangeName,
      bedExchangeNames,
      nameOriginal,
      descriptionOriginal,
      templateIdOriginal,
      footerOriginal,
      timeHeaderFormatOriginal,
      locationStatusesDisplayOriginal,
      scrollDurationOriginal,
      departmentExchangeNameOriginal,
      bedExchangeNamesOriginal,
    } = this.state

    const templateItems = data.templates.map(template =>
      <MenuItem key={template.id} value={template.id} primaryText={template.name} />,
    )

    const departmentItems = data.departmentItems
    const bedMap = data.bedMap

    const noValueChanged = (name === nameOriginal)
      && (description === descriptionOriginal)
      && (footer === footerOriginal)
      && (timeHeaderFormat === timeHeaderFormatOriginal)
      && (locationStatusesDisplay === locationStatusesDisplayOriginal)
      && (scrollDuration === scrollDurationOriginal)
      && (templateId === templateIdOriginal)
      && (departmentExchangeName === departmentExchangeNameOriginal)
      && (JSON.stringify(bedExchangeNames)==JSON.stringify(bedExchangeNamesOriginal))

    const anyRequiredValueUnPopulated = !name || !description || !templateId || bedExchangeNames.length === 0

    const applyDisabled = noValueChanged || anyRequiredValueUnPopulated

    const applyButtonStyle = !applyDisabled && {
      labelStyle: {
        color: 'white',
      },
    }

    const actions = [
      <FlatButton
        key="apply"
        label="Apply"
        disabled={applyDisabled}
        {...applyButtonStyle}
        onClick={this.onApplyHandler}
      />,
    ]

    return (
      <div>
        <DrawerHeaderBar
          title={title}
          iconElementLeft={
            <IconButton onClick={onRequestClose}>
              <NavigationClose />
            </IconButton>
          }
          actions={actions}
        />

        <div className="row">
          <div className="col-xs-1" />
          <div className="col-xs-5">
            <StatefulTextField
              text={this.state.name}
              textFieldProps={{
                fullWidth: true,
                hintText: 'Name *',
                disabled: this.state.isSubmitting,
                floatingLabelText: 'Name *'
              }}
              onChange={this.handleNameUpdate}
              maxNumberOfChars={255}
              clearOnTextEntered={false}
              showCharacterCount
            />
            <StatefulTextField
              text={this.state.description}
              textFieldProps={{
                fullWidth: true,
                hintText: 'Description *',
                disabled: this.state.isSubmitting,
                floatingLabelText: 'Description *'
              }}
              onChange={this.handleDescriptionUpdate}
              maxNumberOfChars={255}
              clearOnTextEntered={false}
              showCharacterCount
            />
            <SelectField
              fullWidth
              floatingLabelShrinkStyle={{whiteSpace: 'nowrap'}}
              floatingLabelText="Template *"
              value={templateId}
              onChange={this.handleTemplateIdUpdate}
            >
              {templateItems}
            </SelectField>
            <StatefulTextField
              text={this.state.footer}
              textFieldProps={{
                fullWidth: true,
                hintText: 'Footer',
                disabled: this.state.isSubmitting,
                floatingLabelText: 'Footer'
              }}
              onChange={this.handleFooterUpdate}
              maxNumberOfChars={255}
              clearOnTextEntered={false}
              showCharacterCount
            />
            <SelectField
              fullWidth
              floatingLabelShrinkStyle={{whiteSpace: 'nowrap'}}
              floatingLabelText="Scroll Duration"
              value={scrollDuration}
              onChange={this.handleScrollDurationUpdate}
            >
              {this.scrollDurationDisplayItems}
            </SelectField>
          </div>
          <div className="col-xs-5">
            <StatefulTextField
              text={this.state.timeHeaderFormat}
              textFieldProps={{
                fullWidth: true,
                hintText: 'Time Header Format',
                disabled: this.state.isSubmitting,
                floatingLabelText: 'Time Header Format'
              }}
              onChange={this.handleTimeHeaderFormatUpdate}
              maxNumberOfChars={60}
              clearOnTextEntered={false}
              showCharacterCount
            />
            <SelectField
              fullWidth
              floatingLabelShrinkStyle={{whiteSpace: 'nowrap'}}
              floatingLabelText="Location Statuses Display"
              value={locationStatusesDisplay}
              onChange={this.handleLocationStatusesDisplayUpdate}
            >
              {this.locationStatusesDisplayItems}
            </SelectField>
            <SelectField
              fullWidth
              floatingLabelShrinkStyle={{whiteSpace: 'nowrap'}}
              floatingLabelText="Department *"
              value={departmentExchangeName}
              onChange={this.handleDepartmentExchangeNameUpdate}
            >
              {departmentItems}
            </SelectField>
            <SelectField
              floatingLabelText="Beds *"
              fullWidth
              onChange={this.handleBedExchangeNamesUpdate}
              multiple>
              {bedMap[departmentExchangeName].map(bed => (
                <MenuItem
                  key={bed.exchangeName}
                  value={bed.exchangeName}
                  primaryText={<div className="menu-item">{bed.name}</div>}
                  checked={typeof bedExchangeNames.find((bedExchangeName) => bedExchangeName === bed.exchangeName) !== "undefined"}
                  insetChildren
                />
              ))}
            </SelectField>
            <span>{bedExchangeNames.length} bed(s) selected</span>
          </div>
          <div className="col-xs-1" />
        </div>
      </div>
    )
  }

}
export default connect(null, mapDispatchToProps)(EditVisibilityBoardEntry)
